import { httpRequest } from "../../http";
import type { Correction } from "@models/Discrepancy.model";

/** A discrepancy's corrections, or a population's. */
export class CommandListCorrections {
  async run(scope: { discrepancyId?: number; populationSegmentId?: number }): Promise<Correction[]> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/`;
    const url = scope.discrepancyId
      ? `${base}discrepancies/${scope.discrepancyId}/corrections/`
      : `${base}corrections/?population_segment=${scope.populationSegmentId}`;
    return httpRequest<Correction[]>(url, { method: "GET" });
  }
}
